import * as React from 'react'
import { Route }  from 'react-router'

export function createRoutes(baseRoutes: any) {
  return baseRoutes.map((item: any, index: Number) => {
    return (
      <Route exact path={ item.path } component={ item.component } key={ `react-router--${ index }` }></Route>
    )
  })
}
